'use strict';
const React = require('react');
const toastr = require('toastr');
const BaseComponent = require('../../views/shared/base');
let client = require('../../../sdk/client');
let AvailabiltyModalComponent = require('../../../src/views/custom/item-detail/availabilitymodal.jsx');
const ItemPriceComponent = require('../features/pricing_type/' + process.env.PRICING_TYPE + '/home/item-price');
var ItemsHome = require('../../views/home/items');
const BannersItemDetail = require('../custom-views/item/banners-item-detail')
const ItemsPartesComponent = require('../custom-views/item/items-parts');
const PurchaseOrderComponent = require('./purchase-order');

var Numeral = require('numeral');
const empty = require('../../redux/reducers/empty.js');
let format = process.env.MONEY_FORMAT;

if (typeof window !== 'undefined') {
    var $ = window.$;
}

class ItemInfoComponent extends BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            availability: "-",
            address: undefined,
            arrPartesRelacionadas: [],
            strSalePrice: "-",
            strCorePrice: "",
            strMXNPrice: "-",
            linkSupercesor:"#",
            salesUnit: "1"
        }

        this.packageIdAlmacenes = process.env.ADMINISTRACION_ALMACENES;
        this.defaultImage = process.env.ITEM_DEFAULT_IMAGE
    }

	isThisUserB2C(){
        var userIsB2C = true;
        if(this.props.user) {
            if(this.props.user.CustomFields) {
                try {
                    userIsB2C = this.props.user.CustomFields.find(x => x.Name == "Tipo de Usuario").Values[0] === "B2C";
                } catch (error) {
                    console.error(".Find error:", error);
                }
            }
        }
        return userIsB2C;
	}

    componentDidMount() {
        let self = this;
        this.renderThumbnailImages2();
        this.imageZoom("img-main", "myResultZoom");
        $("#container-img1").hover(function () {
            $('#container-img-main').removeClass('hide-zoom');

        }, function () {
            $('#container-img-main').addClass("hide-zoom");
        });
        $('#container-img-main').addClass("hide-zoom");

        var userId = self.props.user.ID;

        if(userId.includes('00000000') && (process.env.BASE_URL == "bepensab2c.staging.arcadier.io" || process.env.BASE_URL == "bepensab2c.sandbox.arcadier.io" || process.env.BASE_URL == "bepensademo.sandbox.arcadier.io")){
            userId = "d500bd4d-d8ff-4b84-8bf2-8e1bdbd444a1";
        } else if(userId.includes('00000000') && process.env.BASE_URL == "bepensa.arcadier.io"){
            userId = "b1f6a947-5716-475d-87e5-8be4d3198ce6";
        }
        
        client.Users.getUserDetails({
            excludeToken: false,
            userId: userId,
            includeUserCustomFields: true
        }, function (err, user) {
            if (err == null && user != null) {
                // self.props.user.CustomFields = user.CustomFields;
                //Cart functionality
                if(user.CustomFields != undefined) {
                    user.CustomFields.forEach(cf => {    
                        var found = true;    
                        try {
                            if(self.props.user.CustomFields == undefined) {
                                found = false;
                            } else {
                                found = self.props.user.CustomFields.find(prp => cf.Name == prp.Name);
                            }
                        } catch (error) {
                            console.error(".Find error:", error);
                        }
        
                        if(!found){
                            if(self.props.user.CustomFields != undefined) {
                                self.props.user.CustomFields.push(cf);
                            }
                        }
                    });
                } else {

                }

                self.renderAvailabilityApiCalls(user);
                self.loadPartesRelacionadas(self.props.itemDetails.CustomFields);
                self.loadSalesUnit(self.props.itemDetails.CustomFields);
            }
        });

        setTimeout(function(){
            var partQty = $("#partQty").text();
            if(partQty == '-') {
                var userId = self.props.user.ID;

                client.Users.getUserDetails({
                    excludeToken: false,
                    userId: userId,
                    includeUserCustomFields: true
                }, function (err, user) {
                    if (err == null && user != null) {
                        // self.props.user.CustomFields = user.CustomFields;
                        //Cart functionality
                        if(user.CustomFields != undefined) {
                            user.CustomFields.forEach(cf => {    
                                var found = true;    
                                try {
                                    if(self.props.user.CustomFields == undefined) {
                                        found = false;
                                    } else {
                                        found = self.props.user.CustomFields.find(prp => cf.Name == prp.Name);
                                    }
                                } catch (error) {
                                    console.error(".Find error:", error);
                                }
                
                                if(!found){
                                    if(self.props.user.CustomFields != undefined) {
                                        self.props.user.CustomFields.push(cf);
                                    }
                                }
                            });
                        }

                        self.renderAvailabilityApiCalls(user);
                        self.loadPartesRelacionadas(self.props.itemDetails.CustomFields);
                        self.loadSalesUnit(self.props.itemDetails.CustomFields);
                    }
                });
            }
        }, 1000);

        //                                                  //Try to render MXN prices once the exchange currency has
        //                                                  //      been got.
        this.subRefreshCurrency();

        //initialize slider carusel images
        $(".myitems-carousel").slick({
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            
        })

        this.buildLinkSupercesor();

        /*const script = document.createElement("script");

        script.innerHTML = `
            gtag('event', 'view_item', {
                'app_name': 'Megamak',
                'item_visited': 'Item: ${this.getPartNumber()} ${this.props.itemDetails.BuyerDescription}
            });`

        document.body.appendChild(script);*/

        window.gtag("event", "view_item", {
            'app_name': 'Megamak',
            'item_visited': 'Item: ' + this.getPartNumber() + " " + this.props.itemDetails.BuyerDescription
        });
    }

    componentDidUpdate(prevProps, prevState) {
        // Check if availability has changed
        if (this.state.availability !== prevState.availability) {
            // If the new availability is less than the old one, set the state back to the old value
            if (this.state.availability < prevState.availability) {
                this.setState({ availability: prevState.availability });
                document.getElementById('partQty').innerHTML = prevState.availability;
            } else {
                const minSaleQty = this.props.itemDetails.CustomFields[6].Values[0];
                if (this.state.availability < minSaleQty) {
                    var userIsB2C = true;
                    if(this.props.user) {
                        if(this.props.user.CustomFields) {
                            try {
                                userIsB2C  = this.props.user.CustomFields.find(x => x.Name == "Tipo de Usuario").Values[0] === "B2C";
                            } catch (error) {
                                console.error(".Find error:", error);
                                userIsB2C = true;
                            }
                        }
                    }
                    
                    if (userIsB2C && document.getElementById('itemAddCart')) {
                        document.getElementById('itemAddCart').style.display = "none";
                    }
                }
                var userIsB2C;
                if(this.props.user) {
                    if(this.props.user.CustomFields) {
                        try {
                            userIsB2C  = this.props.user.CustomFields.find(x => x.Name == "Tipo de Usuario").Values[0] === "B2C";
                        } catch (error) {
                            console.error(".Find error:", error);
                            userIsB2C = true;
                        }            
                    }
                }
                const itemDetailsElements = document.getElementsByClassName('existencia item-details');
                if (userIsB2C && itemDetailsElements.length > 0) {
                    const itemDetailsElement = itemDetailsElements[0];
                    itemDetailsElement.id = "itemDetailsB2C";
                }
            }
        }
    }

    subRefreshCurrency()

    {
        let currency = $("#exchange-currency").attr("currency");
        let strCurrencyCode = "";
        let currencyCodeCf = null;
        const { itemDetails, defaultPrice } = this.props;
        
        if(itemDetails.CustomFields != null){
            try {
                currencyCodeCf = itemDetails.CustomFields.find(x => x.Name == "Currency");   
                if (currencyCodeCf != undefined || currencyCodeCf != null) {
                    if(currencyCodeCf.Values[0].length > 0){
                        strCurrencyCode = currencyCodeCf.Values[0];
                    }                        
                }
            } catch (error) {
                console.error(".Find error:", error);
                userIsB2C = true;
            }
        }    
                                     
        if(currency != null && currency != "-"){
            
            let strMXNPrice = defaultPrice;

            if(strCurrencyCode != "MXN"){
                strMXNPrice = defaultPrice * currency;
            }
            
            let coreCustomField = null;
            let corePrice = "";
            if (
                itemDetails.CustomFields != null
                ) 
            {
                try {
                    coreCustomField = itemDetails.CustomFields.find(cf => cf.Name == "Precio Core");
                } catch (error) {
                    console.error(".Find error:", error);
                    coreCustomField = null
                }
                
                if (
                    coreCustomField != null
                    ) 
                {
                    corePrice = coreCustomField.Values[0] || "0";
                    if(strCurrencyCode != "MXN"){
                        corePrice = parseFloat(corePrice) * currency;
                    }
                }
            }

            this.setState({"strMXNPrice":strMXNPrice});
            this.setState({"strCorePrice":corePrice});
        }else{
            setTimeout(() => {
                this.subRefreshCurrency();
            }, 500);
        }
    }

    generateSlug(itemName) {
        return itemName.replace(/[^a-zA-Z0-9\-]/g, "");
    }

    itemUrl(itemName, itemId) {
        return "/items/" + this.generateSlug(itemName) + "/" + itemId;
    }

    renderCorePrice() {
        const { itemDetails } = this.props;

        let coreCustomField = null;
        if (
            itemDetails.CustomFields != null
            ) 
        {
            try {
                coreCustomField = itemDetails.CustomFields.find(cf => cf.Name == "Precio Core");
            } catch (error) {
                console.error(".Find error:", error);
            }
        }
        // If item is not a Recon item AKA does not have CF for Core Price, return empty div
        if (coreCustomField !== null && coreCustomField !== undefined) {
            if (coreCustomField.Code == process.env.CF_CORE_PRICE) {
                if (coreCustomField.Values[0].length > 0 && coreCustomField.Values[0] !== "") {

                    return (
                        <div className="item-price">
                            <span id="item-price-core">Precio core: </span>
                            <span className="price-i-detail price item-categ">$ {Numeral(this.state.strCorePrice).format(format)} MXN</span>
                        </div>
                    )

                }

            }
        }
    }


    renderRating(AverageRating) {
        let self = this;
        return (
            <div className="item-rating">
                <span className="stars"><span style={{ width: `${AverageRating * 20 || 0}%` }} /></span>
                <span className="feedback-text">({`${this.props.PositiveFeedbackPercentage || 0}%`} positive feedback)</span>
            </div>
        );
    }

    renderLogoImage() {
        if (this.props.itemDetails.Media != null && this.props.itemDetails.Media.length > 0) {
            return (
                <div className="container-img-main">
                    <a className="item-main-thumbnail" rel="lightbox" href={this.props.itemDetails.Media[0].MediaUrl} data-lightbox={this.props.itemDetails.Media.length > 1 ? "gallery-group" : "gallery"} id="item-thumbnail">
                        <img alt="" className="item-big-img img-main" src={this.props.itemDetails.Media[0].MediaUrl} />
                    </a>
                    {
                        this.props.itemDetails.Media.slice(1).map(function (obj) {
                            return <a rel="lightbox" key={obj.ID} href={obj.MediaUrl} data-lightbox="gallery-group" id="item-thumbnail">
                                <img alt="" className="item-big-img" src={obj.MediaUrl} style={{ display: 'none' }} />
                            </a>
                        })
                    }
                </div>

            );
        }
        return '';
    }

    imageZoom(imgID, resultID) {
        var img, lens, result, cx, cy;
        img = document.getElementById(imgID);
        result = document.getElementById(resultID);
        /*create lens:*/
        lens = !!document.getElementById('visor');
        if (lens) {
            lens = document.getElementById("visor");
        } else {
            lens = document.createElement("DIV");
            lens.setAttribute("class", "img-zoom-lens");
            lens.setAttribute("id", "visor")
            lens.style.width = "120px"
            lens.style.height = "120px"
        }
        // lens = document.createElement("DIV");
        // lens.setAttribute("class", "img-zoom-lens");
        /*insert lens:*/
        if (img != null) {
            img.parentElement.insertBefore(lens, img);
            /*calculate the ratio between result DIV and lens:*/
            cx = result.offsetWidth / lens.offsetWidth;
            cy = result.offsetHeight / lens.offsetHeight;
            /*set background properties for the result DIV:*/
            result.style.backgroundImage = "url('" + img.src + "')";
            result.style.backgroundSize = (img.width * cx) + "px " + (img.height * cy) + "px";
            /*execute a function when someone moves the cursor over the image, or the lens:*/
            lens.addEventListener("mousemove", moveLens);
            img.addEventListener("mousemove", moveLens);
            /*and also for touch screens:*/
            lens.addEventListener("touchmove", moveLens);
            img.addEventListener("touchmove", moveLens);
        }
        function moveLens(e) {
            var pos, x, y;
            /*prevent any other actions that may occur when moving over the image:*/
            e.preventDefault();
            /*get the cursor's x and y positions:*/
            pos = getCursorPos(e);
            /*calculate the position of the lens:*/
            x = pos.x - (lens.offsetWidth / 2);
            y = pos.y - (lens.offsetHeight / 2);
            /*prevent the lens from being positioned outside the image:*/
            if (x > img.width - lens.offsetWidth) { x = img.width - lens.offsetWidth; }
            if (x < 0) { x = 0; }
            if (y > img.height - lens.offsetHeight) { y = img.height - lens.offsetHeight; }
            if (y < 0) { y = 0; }
            /*set the position of the lens:*/
            lens.style.left = x + "px";
            lens.style.top = y + "px";
            /*display what the lens "sees":*/
            result.style.backgroundPosition = "-" + (x * cx) + "px -" + (y * cy) + "px";
        }
        function getCursorPos(e) {
            var a, x = 0, y = 0;
            e = e || window.event;
            /*get the x and y positions of the image:*/
            a = img.getBoundingClientRect();
            /*calculate the cursor's x and y coordinates, relative to the image:*/
            x = e.pageX - a.left;
            y = e.pageY - a.top;
            /*consider any page scrolling:*/
            x = x - window.pageXOffset;
            y = y - window.pageYOffset;
            return { x: x, y: y };
        }
    }

    renderCFAntecesor(){    
        let antecesor;
        try {
            antecesor = this.props.itemDetails.CustomFields.find(x => x.Code == process.env.CF_ANTECESOR);
        } catch (error) {
            console.error(".Find error:", error);
        }

        let strAntecesor = "-";
        if (
            antecesor != undefined
            )
        {
            strAntecesor = antecesor.Values[0];
            if(strAntecesor !== ""){
                return (
                    <div id="container-first" className="sub-container-dimensiones-item">
                        <span className="">Parte antecesora:</span>
                        <span className="item-categ" id="part-antecesor">{strAntecesor}</span>
                    </div>
                                        
                )
            }
        }
           
    }

    buildLinkSupercesor(){
        let supercesor;
        try {
            supercesor = this.props.itemDetails.CustomFields.find(x => x.Code == process.env.CF_SUPERCESOR);
        } catch (error) {
            console.error(".Find error:", error);
        }
        
        let strSupercesor = "-";
        if (
            supercesor != undefined &&
            supercesor.Values[0] !==""
            )
        {
            strSupercesor = supercesor.Values[0];
            
            
            const promiseProductInfo = new Promise((resolve, reject) => {
                const options = {
                    "arrNumberParts": [ strSupercesor]
                }
                client.CustomSearch.SearchAndFilterItemAsArcadierAPI(options).then(
                    (response) => {
                        if( response.Records.length !=0){
                            var dataItem = response.Records[0];

                            let numParte;
                            try {
                                dataItem = dataItem.CustomFields.find(x => x.Code == process.env.CF_PART_NUMBER);
                            } catch (error) {
                                console.error(".Find error:", error);
                            }
                            if (
                                numParte != undefined
                                )
                            {
                                let nPart = numParte.Values[0];
                                if(strSupercesor === nPart){
                                    var link = this.itemUrl(dataItem.Name, dataItem.ID)
                                    this.setState({
                                        linkSupercesor: link
                                    })
                                }
                            }
                        }
                    }
                ).catch(error => console.error(error));            
            });
        }
    }

    
    renderCFSupercesor(){
        let supercesor; 
        try {
            supercesor = this.props.itemDetails.CustomFields.find(x => x.Code == process.env.CF_SUPERCESOR);
        } catch (error) {
            console.error(".Find error:", error);
        }
                            
        let nparteItem;
        try {
            nparteItem = this.props.itemDetails.CustomFields.find(x => x.Code == process.env.CF_PART_NUMBER);
        } catch (error) {
            console.error(".Find error:", error);
        }
        let strSupercesor = "-";
        if (
            supercesor != undefined
            )
        {
            strSupercesor = supercesor.Values[0];
            if(nparteItem !== undefined && nparteItem.Values[0] !== "" && nparteItem.Values[0] !== strSupercesor){
                if(strSupercesor !== ""){
                    return (
                        <div id="container-second" className="sub-container-dimensiones-item">
                            <span className="">Parte supercesora:</span>
                            <a href={this.state.linkSupercesor}>
                                <span className="item-categ" id="part-suprecesor">{strSupercesor}</span>
                            </a>
                            
                        </div>
                                            
                    )
                }
            }
            
        }
    }

    renderDimensionesMobile(){
        const { itemDetails } = this.props;
	    var classHide = "";
	    if(!itemDetails.HeightUnit && !itemDetails.WidthUnit && !itemDetails.WeightUnit && !itemDetails.LengthUnit) {
		    classHide = 'hide';
	    }
        return(
            <div id="container-dimensiones-mobile" className="container-dimensiones">
                <div id="container-second-row" className="container-dimensiones-item">
                    {this.renderCFAntecesor()}
                    {this.renderCFSupercesor()}
                </div>
                <div className={classHide}>
                    <div className="sub-title-dimensiones">Dimensiones</div>
                    {this.renderFirstRow()}
                    {this.renderSecondRow()}
                </div>
            </div>
        );
    }

    renderLogoImage2() {
        let Media = [];

        if (this.props.itemDetails.Media == null) {
            Media = [{
                "ID": "86cdd62f-2ccc-494d-9873-0ae0095ba4d5",
                "MediaUrl": process.env.ITEM_DEFAULT_IMAGE
            }];

            this.props.itemDetails.Media = Media;

        }

        if (this.props.itemDetails.Media != null && this.props.itemDetails.Media.length > 0) {
            const { itemDetails } = this.props;
	        var classHide = "";
	        if(!itemDetails.HeightUnit && !itemDetails.WidthUnit && !itemDetails.WeightUnit && !itemDetails.LengthUnit) {
                classHide = 'hide';
	        }
            return (
                <div className="container-img-main" id="container-img-main">
                    {/*<img id="img-main" className="item-big-img img-main" src={this.state.srcImgMain} />*/}

                    <div>
                        <div id="container-img1" className="container-img1">
                            {<img alt="" id="img-main" className="item-big-img img-main" src={this.props.itemDetails.Media[0].MediaUrl} />}

                            
                        </div>
                        <div id="container-dimensiones" className="container-dimensiones">
                            <div id="container-second-row">
                                {this.renderCFAntecesor()}
                                {this.renderCFSupercesor()}
                            </div>
                            <div className={classHide}>
                                <div className="sub-title-dimensiones">Dimensiones</div>
                                {this.renderFirstRow()}
                                {this.renderSecondRow()}
                            </div>
                        </div>
                    </div>
                    
                    {this.renderLogoImageZoom()}

                </div>
            );
        }
        return '';
    }

    renderLogoImageZoom() {
        return (
            <div id="myResultZoom" className="img-zoom-result">
            </div>
        );
    }

    renderThumbnailImages2() {
        const { Media } = this.props.itemDetails;
        //initialize slider
        $(".slick-slider").slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 3,
            vertical: true,
            draggable: true,
        })
        //map images

        if (Media) {
            var indexImgSlider = 0;


            Media.map(function (m) {
                $(".slick-slider").slick('slickAdd',
                    `<div>
                        <li style="width: '100%'; display: 'inline-block'" key=${m.MediaUrl}>
                            <div id="container-img-slider-${indexImgSlider}" srcImg=${m.MediaUrl}>
                                <img src=${m.MediaUrl} alt="thumbnail" className="img-responsive" style="width: 100%" />
                            </div>
                        </li>
                    </div>`
                )
                $('#container-img-slider-' + indexImgSlider).click((ev) => {
                    var img = ev.currentTarget.getAttribute('srcImg');
                    $('#container-img-main').removeClass('hide-zoom'); 
                    $("#img-main").attr("src", img);
                    this.imageZoom("img-main", "myResultZoom")
                    $('#container-img-main').addClass("hide-zoom");
                });

                indexImgSlider = indexImgSlider + 1;
            }.bind(this));

        }
        // configure prev and next        
        $(".slick-next, .slick-prev").hide();
        $(".bottom_slide").on("click", function () {
            $(".slick-next").trigger("click");
        });
        $(".top_slide").on("click", function () {
            $(".slick-prev").trigger("click");
        });
    }

   


    renderThumbnailImages() {
        const { Media } = this.props.itemDetails;
        //initialize slider
        $(".slick-slider").slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 3,
            vertical: true,
            draggable: true,
        })
        //map images

        if (Media) {
            Media.map(m =>
                $(".slick-slider").slick('slickAdd',
                    `<div>
                        <li style="width: '100%'; display: 'inline-block'" key=${m.MediaUrl}>
                            <a data-lightbox="group" data-imgurl="${m.MediaUrl}" href=${m.MediaUrl} tabIndex="0">
                                <img src=${m.MediaUrl} alt="thumbnail" className="img-responsive" style="width: 100%" />
                            </a>
                        </li>
                    </div>`
                )
            )
        }
        // configure prev and next        
        $(".slick-next, .slick-prev").hide();
        $(".bottom_slide").on("click", function () {
            $(".slick-next").trigger("click");
        });
        $(".top_slide").on("click", function () {
            $(".slick-prev").trigger("click");
        });
    }

    renderOfferIcon(item) {
        
        var styleOffersHide = "none";

        try {
            if (item.Categories.find(x => x.ID == process.env.OFFERS) != undefined) {
                styleOffersHide = "";
            }
        } catch (error) {
            console.error(".Find error:", error);
        }
        
        return (
                <div className="col-6" style={{display: 'flex'}}>
                    <div className="icon-offers-c" id="icon-offers" style={{display: styleOffersHide}}>
                        <div id="star-offers">&#10040;</div>
                        <div id="character-offers">%</div>
                        <div id = "offers-text" style={{display: styleOffersHide}}>Oferta</div>
                    </div>
                </div>
            
        );
    }

    renderReconIcon(item) {
        //TODO: Change hardcoded Category for reusability
        var itemCF = null;
        var styleCoreHide = "none";

        try {
            if (item.CustomFields != null) {
                itemCF = item.CustomFields.find(cf => cf.Name == "Precio Core");
            }
        } catch (error) {
            console.error(".Find error:", error);
        }

        if (itemCF != null && itemCF.Values[0] != "") {
            styleCoreHide = "";
        }

        return (
                <div className="col-6" style={{display: 'flex'}}>
                    <div id="icon-recon" style={{display: styleCoreHide}}>
                        <div id="star-recon"><img alt="" style={{width:'20px'}} src="/assets/images/bepensa/recon-icon2-white.png" /></div>
                    </div>
                    <div id = "recon-text" style={{display: styleCoreHide}}>Recon</div>
                </div>
            
        );
    }

    renderAvailability() {
        const checkUsersType = this.isThisUserB2C();
        let existenceClasses = 'existencia item-details';
        if(!checkUsersType){
            existenceClasses += ' existence-details'
        }
        //if(this.props.user.Guest === false)
        //{
            return (<span className={existenceClasses} onClick={() => this.displayModal('modal-availability')}>Existencias: <span id="partQty">{this.state.availability}</span></span>);
        //}
    }

    displayModal(modalId) {
        const checkUsersType = this.isThisUserB2C();

        if(checkUsersType){
            $('#modal-availability').modal({ 'show': false });
        } else {
            $(`#${modalId}`).modal({ 'show': true });
        }
    }

    renderAvailabilityApiCalls(user) {
        //                                                  //Those values are taken from the widget.
        var addressId = $('#address-name').attr('addressid');
        var depotId = document.getElementById("address-name").getAttribute("billing-address-lider");
        let self = this;
        var userId;
        
        if(user.Guest) {
            userId = "b1f6a947-5716-475d-87e5-8be4d3198ce6";
            addressId = "68834010-4291-4dfc-9af1-523508af9218";
            depotId = 11;
        } else {
            userId = user.ID;
        }

        //B2C function to handle all the stock 
        // if(user.Guest == false && user.CustomFields[4].Values[0]=="B2C"){
        
        try {
            var isB2C = true;
            //if(user.Guest == false && user.CustomFields.find(x => x.Name == "Tipo de Usuario").Values[0]=="B2C"){
            if(user.CustomFields) {
                isB2C = user.CustomFields.find(x => x.Name == "Tipo de Usuario").Values[0]=="B2C";
            }
            if(isB2C) {        
                const strPartNumber = this.getPartNumber();
                //Prepare promise for warehouses collection
                const promiseSucursales = new Promise((resolve, reject) => {
                    const options = {
                        pluginId: process.env.ADMINISTRACION_ALMACENES,
                        tableName: "Almacenes",
                        query: [
                            {
                                Name: 'IsActive',
                                Operator: "eq",
                                Value: "true"
                            }
                        ]
                    };
                    client.CustomTables.searchCustomTable(options, function (err, result) {
                        resolve(result);
                    });
                });
                var userId;
                if(user.Guest) {
                    userId = "b1f6a947-5716-475d-87e5-8be4d3198ce6";
                    addressId = "68834010-4291-4dfc-9af1-523508af9218";
                    depotId = 11;
                } else {
                    userId = user.ID;
                }
                const promiseUserConfiguration = new Promise((resolve, reject) => {
                    const options = {
                        pluginId: process.env.ADMINISTRACION_ALMACENES,
                        tableName: "ConfiguracionUsuario",
                        query: [
                            {
                                Name: "UserId",
                                Operator: "equal",
                                Value: userId
                            },
                            {
                                Name: "AddressId",
                                Operator: "equal",
                                Value: addressId
                            }
                        ]
                    };

                    client.CustomTables.searchCustomTable(options, function (err, result) {
                        resolve(result);
                    });
                });
                const requestBody = {
                    "operatingUnitId": 446,
                    "partsCode": [
                        {
                            "partCode": strPartNumber
                        }
                    ]
                };
                const promiseapilider = client.Availability.GetAvalability(requestBody);
                const { itemDetails } = this.props;
                let isItemOffer = this.boolIsItemOffer(itemDetails);
                let userType;
                try {
                    if (itemDetails.CustomFields != null) {
                        userType  = user?.CustomFields != null ? user?.CustomFields.find(cf => cf.Name == "Tipo de Usuario")?.Values[0] : null;
                    }
                } catch (error) {
                    console.error(".Find error:", error);
                }
        
                let externalUserId;
                try {
                    if (itemDetails.CustomFields != null) {
                        externalUserId = user.CustomFields != null ? user.CustomFields.find(cf => cf.Name == "Cliente ID") : null;
                    }
                } catch (error) {
                    console.error(".Find error:", error);
                }
                const priceParams = {
                    deptoId: depotId,
                    currencyCode: "MXN",
                    customerId: externalUserId != null ? externalUserId.Values[0] : "0",
                    orderTypeCode: userType != null && userType === "B2C" ? "PEDIDOS INTERNET" : isItemOffer ? "NORMAL" : "PROGRAMADO",
                    detail: [
                        {
                            partCode: strPartNumber
                        }
                    ]
                };
                const promisePrice = client.BepensaPrices.getBepensaPricesByPartNumbers(priceParams);
                Promise.all([promiseUserConfiguration, promiseapilider, promiseSucursales, promisePrice]).then(response => {
                    let avalabilityesTotal = 0;
                
                            let avalabilityes = response[1].Parts[0].Availabilitys;
                            avalabilityes.forEach(element=>{
                                avalabilityesTotal = element.Availability + avalabilityesTotal;
                            })

                            //For testing purposes in Sandbox
                            //avalabilityesTotal = Math.floor(Math.random() * 30);
                            //
                            this.setState({ "availability": avalabilityesTotal });
                            //Handler response for client prices
                            if (
                                response[3] != null &&
                                response[3].Result != undefined && response[3].Result == 0 &&
                                response[3].PartsCode != undefined && response[3].PartsCode.length > 0
                            ) {
                                var salePrice = "-";
                                var saleCorePrice = "-";
                                console.log("Precios recibidos de lider: ");
                                console.log(response[3]);
                                if (
                                    response[3].PartsCode[0].PartsPrices != null && response[3].PartsCode[0].PartsPrices.length > 0
                                ) {
                                    if (
                                        response[3].PartsCode[0].PartsPrices != null && response[3].PartsCode[0].PartsPrices[0] != null &&
                                        response[3].PartsCode[0].PartsPrices[0].SalePrice != null
                                    ) {
                                        salePrice = response[3].PartsCode[0].PartsPrices[0].SalePrice;
                                        if (response[3].PartsCode[0].PartsPrices[0].CorePart != null && response[3].PartsCode[0].PartsPrices[0].CorePart.SalePrice != null) {
                                            saleCorePrice = response[3].PartsCode[0].PartsPrices[0].CorePart.SalePrice
                                        }
                                    }
                                }


                                this.setState({ "strSalePrice": salePrice });

                                if (salePrice == "-") {
                                    // Si no lo encuentra, le ponemos el mismo precio que tenemos en strMXNPrice.
                                    this.setState({ "strSalePrice": self.state.strMXNPrice });
                                    //toastr.warning("No se encontró precio cliente para este número de parte.");
                                }
                            }
                            else {
                                    //toastr.warning("No se pudo obtener el precio cliente de este artículo, inténtelo más tarde");
                                    // Si no lo encuentra, le ponemos el mismo precio que tenemos en strMXNPrice.
                                    this.setState({ "strSalePrice": self.state.strMXNPrice });
                            }

                            //This method listen when addresId changed
                            this.addressChanged();
                    
                });
            }
        } catch (error) {
            console.error(".Find error:", error);
        }

        //B2B function 
        if (addressId != null && (depotId != null && depotId != "")) {
            //set State for address
            this.setState({ "address": addressId });
            if (user.Guest == false) {
                // Get part number/code from the ItemDetails CF.
                const strPartNumber = this.getPartNumber();

                //Prepare promise for warehouses collection
                const promiseSucursales = new Promise((resolve, reject) => {
                    const options = {
                        pluginId: process.env.ADMINISTRACION_ALMACENES,
                        tableName: "Almacenes",
                        query: [
                            {
                                Name: 'IsActive',
                                Operator: "eq",
                                Value: "true"
                            }
                        ]
                    };

                    client.CustomTables.searchCustomTable(options, function (err, result) {
                        resolve(result);
                    });
                });

                //Prepare promise for warehouses coonfiguration

                const promiseUserConfiguration = new Promise((resolve, reject) => {
                    const options = {
                        pluginId: process.env.ADMINISTRACION_ALMACENES,
                        tableName: "ConfiguracionUsuario",
                        query: [
                            {
                                Name: "UserId",
                                Operator: "equal",
                                Value: user.ID
                            },
                            {
                                Name: "AddressId",
                                Operator: "equal",
                                Value: addressId
                            }
                        ]
                    };

                    client.CustomTables.searchCustomTable(options, function (err, result) {
                        resolve(result);
                    });
                });

                //Prepare promise for Availabilities for this item.

                const requestBody = {
                    "operatingUnitId": 446,// esto debe ir fijo
                    //"depotID": 7201, // esto se debe de quitar en una proximo update de endpoint
                    "partsCode": [
                        {
                            "partCode": strPartNumber
                        }
                    ]
                };

                const promiseapilider = client.Availability.GetAvalability(requestBody);

                //Prepare promise for "client price" for this item.
                const { itemDetails } = this.props;
                let isItemOffer = this.boolIsItemOffer(itemDetails);
                let userType;
                try {
                    userType = user?.CustomFields != null ? user?.CustomFields.find(cf => cf.Name == "Tipo de Usuario")?.Values[0] : null;
                } catch (error) {
                    console.error(".Find error:", error);
                }

                let externalUserId;
                try {
                    externalUserId  = user.CustomFields != null ? user.CustomFields.find(cf => cf.Name == "Cliente ID") : null;
                } catch (error) {
                    console.error(".Find error:", error);
                }
                //To test: 
                //let externalUserId = {Values:["215"]};

                //TODO: validate externalUserId and depotId
                const priceParams = {
                    deptoId: depotId,
                    currencyCode: "MXN",
                    customerId: externalUserId != null ? externalUserId.Values[0] : "0",
                    orderTypeCode: userType != null && userType === "B2C" ? "PEDIDOS INTERNET" : isItemOffer ? "NORMAL" : "PROGRAMADO",
                    detail: [
                        {
                            partCode: strPartNumber
                        }
                    ]
                };

                const promisePrice = client.BepensaPrices.getBepensaPricesByPartNumbers(priceParams);

                Promise.all([promiseUserConfiguration, promiseapilider, promiseSucursales, promisePrice]).then(response => {
                    let avalabilityes = response[1].Parts[0].Availabilitys;
                    let avalabilityesTotal=0;
                    avalabilityes.forEach(element=>{
                        avalabilityesTotal=element.Availability+avalabilityesTotal;
                    })
                    if (response[0].TotalRecords == 1 && response[1].Parts != undefined) {
                        let userConfig = response[0].Records[0];
                        let liderPart = response[1].Parts[0];// solo debe venir una parte porque es consulta de detalle de producto

                        let availabilityConfig = userConfig.VisibilidadExistenciasLiderId.split(','); // generate array of lider id. esto es para el detalle del item

                        let total = 0;
                        availabilityConfig.forEach(liderId => {

                            // liderID esto deberia transformar a numero Number()
                            let sucursal;
                            try {
                                sucursal = liderPart.Availabilitys.find(x => x.DepotId == Number(liderId));
                            } catch (error) {
                                console.error(".Find error:", error);
                            }

                            if (sucursal != undefined) {
                                total += sucursal.Availability;
                            }

                        });

                        //Refresh UI
                        this.setState({ "availability": total });
                    }
                    else if (response[0].TotalRecords == 0 && response[1].Parts != undefined) {
                        let liderPart = response[1].Parts[0];
                        let total = 0;

                        //sumar solo las sucursales que estan dadas de alta en la configuracion en arcadier
                        response[2].Records.forEach(almacen => {
                            let sucursal;
                            try {
                                sucursal = liderPart.Availabilitys.find(x => x.DepotId == Number(almacen.LiderId));
                            } catch (error) {
                                console.error(".Find error:", error);
                            }
                            if (sucursal != undefined) {
                                total += sucursal.Availability;
                            }
                        });

                        //Refresh UI

                        this.setState({ "availability": total });
                    }
                    else {

                    }

                    //Handler response for client prices
                    if (
                        response[3] != null &&
                        response[3].Result != undefined && response[3].Result == 0 &&
                        response[3].PartsCode != undefined && response[3].PartsCode.length > 0
                    ) {
                        var salePrice = "-";
                        var saleCorePrice = "-";
                        if (
                            response[3].PartsCode[0].PartsPrices != null && response[3].PartsCode[0].PartsPrices.length > 0
                        ) {
                            if (
                                response[3].PartsCode[0].PartsPrices != null && response[3].PartsCode[0].PartsPrices[0] != null &&
                                response[3].PartsCode[0].PartsPrices[0].SalePrice != null
                            ) {
                                salePrice = response[3].PartsCode[0].PartsPrices[0].SalePrice;
                                if (response[3].PartsCode[0].PartsPrices[0].CorePart != null && response[3].PartsCode[0].PartsPrices[0].CorePart.SalePrice != null) {
                                    saleCorePrice = response[3].PartsCode[0].PartsPrices[0].CorePart.SalePrice
                                }
                            }
                        }

                        this.setState({ "strSalePrice": salePrice });

                        if (salePrice == "-") {
                            // Si no lo encuentra, le ponemos el mismo precio que tenemos en strMXNPrice.
                            this.setState({ "strSalePrice": self.state.strMXNPrice });
                            //toastr.warning("No se encontró precio cliente para este número de parte.");
                        }
                    }
                    else {
                            //toastr.warning("No se pudo obtener el precio cliente de este artículo, inténtelo más tarde");
                            // Si no lo encuentra, le ponemos el mismo precio que tenemos en strMXNPrice.
                            this.setState({ "strSalePrice": self.state.strMXNPrice });
                    }

                    //This method listen when addresId changed
                    this.addressChanged();
                });
            }
        }else {
            setTimeout(function(){
                self.renderAvailabilityApiCalls(user);
            }, 1000);
        }
    }

    addressChanged() {
        var addressId = $('#address-name').attr('addressid');        
        if (
            this.state.address != null && addressId != this.state.address
        ) {
            //Recalculate availability against address, once finished addressChanged() is called again.
            this.renderAvailabilityApiCalls(this.props.user)
        }
        else {
            //Recursive method called every 1 second
            setTimeout(() => {
                this.addressChanged();
            }, 1000)
        }
    }


    renderMarca(CFs) {
        if (CFs.length) {
            let marca;
            try {
                marca = this.props.itemDetails.CustomFields.find(x => x.Code == process.env.CF_MARCA);
            } catch (error) {
                console.error(".Find error:", error);
            }

            let strMarca = "";
            let strMotor = "";
   	        let strDivider = "";
            if (
                marca != undefined
                )
            {
                strMarca = marca.Values[0];
            }

            CFs.map(function (cf, index) {
                if (cf.Code == process.env.CF_MOTOR) {
                    if (cf.Values[0].length > 0) {
			            strDivider = " / ";
			            strMotor = cf.Values[0];
                    }
                }
            });

            return (
                <div id="container-info-categ" className="item-details">
                    <span className="item-categ"><p><span>{strMarca}{strDivider}{strMotor}</span></p></span>
                </div>
            )
        }

        return '';
    }

    renderCFItemCore(CFs) {
        if (CFs.length) {
            return CFs.map(function (cf, index) {
                if (cf.Code == process.env.CF_CORE_CODE) {
                    if (cf.Values[0].length > 0) {

                        return (
                            <div id="container-info-categ" className="item-details">
                                <span className="">Parte core: </span>
                                <span className="item-categ"><p><span>{cf.Values[0]}</span></p></span>
                            </div>
                        )

                    }

                }
            });
        }

        return '';
    }

    renderCFUnidadVenta(CFs) {
        if (CFs.length) {
            return CFs.map(function (cf, index) {
                if (cf.Code == process.env.CF_SALES_UNIT) {
                    if (cf.Values[0].length > 0) {
                        return (
                            <div>
                                <div id="container-info-categ" className="item-details">  
                                    {cf.Values[0] == 1 &&
                                        <span className="txt-info-item-detail">Venta exclusiva en múltiplos de {cf.Values[0]} pieza</span>
                                    }  

                                    {cf.Values[0]  > 1 &&
                                        <span className="txt-info-item-detail">Venta exclusiva en múltiplos de {cf.Values[0]} piezas</span>
                                    }                                                      
                                </div>
                        </div>
                        )
                    }
                }
            });
        }

        return '';
    }

    renderCFItemMotor(CFs) {
        if (CFs.length) {
            return CFs.map(function (cf, index) {
                if (cf.Code == process.env.CF_MOTOR) {
                    if (cf.Values[0].length > 0) {
                        return (
                            <div key={index} id="container-info-categ" className="item-details">
                                <span className="">Motor: </span>
                                <span className="item-categ"><p><span>{cf.Values[0]}</span></p></span>
                            </div>
                        )
                    }
                }
            });
        }

        return '';
    }


    renderItemCategory(Categories) {
        var strCategories = "";
        var strSubCategories = "";
        var divider = " / ";
        if (Categories.length) {
            Categories.forEach(category => {
                if (category.ID !== process.env.MARCA && category.ParentCategoryID !== process.env.MARCA) {
                    if(category.ParentCategoryID === null){
                        if(category.Name !== "Ofertas")
                            strCategories = strCategories + category.Name + ", ";
                    } else {
                        strSubCategories = strSubCategories + category.Name + ", ";
                    }
                }
            });
            strCategories = strCategories.slice(0, -2)
            strSubCategories = strSubCategories.slice(0, -2)
            return (
                <div className="item-details">
                    <div id="container-info-categ">
                        <span className="item-categ"><p><span>{strCategories}{divider}{strSubCategories}</span></p></span>
                    </div>
                </div>
            )
        }

        return '';
    }

    renderInfoItem() {
        
        return (
            <div>
                <div id="container-info-item-title">
                    <span className="item-title">{this.getPartNumber() + " " + this.props.itemDetails.BuyerDescription}</span>
                </div>

                {this.renderItemCategory(this.props.itemDetails.Categories)}

                {this.renderMarca(this.props.itemDetails.CustomFields)}
                <div className="row" id="icons-item-detail">
                    {this.renderOfferIcon(this.props.itemDetails)}
                    {this.renderReconIcon(this.props.itemDetails)}
                </div>
                

                {this.renderAvailability()}
                
               

            </div>
        );
    }
    renderFirstRow() {
        const { itemDetails } = this.props;
	    var classHeight = (itemDetails.HeightUnit == null) ? 'hide' : '';
	    var classWidthUnit = (itemDetails.WidthUnit == null) ? 'hide' : '';
        return (

            <div id="container-second-row" className="container-dimensiones-item">
                <div id="container-first" className={classHeight}>
                    Alto:<label className="item-categ">{itemDetails.Height} {itemDetails.HeightUnit} </label>
                </div>
                <div id="container-second" className={classWidthUnit}>
                    Ancho: <label className="item-categ">{itemDetails.Width} {itemDetails.WidthUnit} </label>
                    <span ></span>
                </div>
            </div>
        )
    }

    renderSecondRow() {
        const { itemDetails } = this.props;
	    var classWeight = (itemDetails.WeightUnit == null) ? 'hide' : '';
	    var classLengthUnit = (itemDetails.LengthUnit == null) ? 'hide' : '';
        return (
            <div id="container-second-row" className="container-dimensiones-item">
                <div id="container-first" className={classWeight}>
                    Peso: <label className="item-categ">{itemDetails.Weight} {itemDetails.WeightUnit}</label>
                </div>
                <div id="container-second" className={classLengthUnit}>
                    Largo: <label className="item-categ">{itemDetails.Length} {itemDetails.LengthUnit} </label>
                    <span ></span>
                </div>
            </div>
        )
    }

    renderPriceItem() {
        const { itemDetails, defaultPrice } = this.props;
        let priceUnit = itemDetails.PriceUnit ? `${itemDetails.PriceUnit.charAt(0).toUpperCase() + itemDetails.PriceUnit.slice(1)}` : null;
        
        var userGuest = false;
        //var userGuest = true;

        if (typeof this.props.user != 'undefined' && this.props.user.Guest === false) {  
            userGuest = false;
        }
        if(this.state.strMXNPrice == this.state.strSalePrice){
            return(
                <div>
                    <div id="container-info-price">
                        <span className="price-i-detail price item-categ" style={{display: userGuest ? 'none':'block'}}>$ {Numeral(this.state.strMXNPrice).format(format)} MXN</span>
                    </div>
                </div>
            )
        }else{
            return (
                <div>
                    <div id="container-info-price">
                        <span className="price-i-detail price price-real item-categ" style={{textDecoration: userGuest ? 'none':'line-through'}}>$ {Numeral(this.state.strMXNPrice).format(format)} MXN</span>
                        <span className="price-i-detail price-cdesc item-categ" style={{display: userGuest ? 'none':'block'}}> $ {Numeral(this.state.strSalePrice).format(format)} MXN</span>
                    </div>
                </div>
            );
        }
    }
    boolIsItemOffer(
        itemDetails_I
    ) {
        let offerCategory;
        try {
            offerCategory = itemDetails_I.Categories != null ? itemDetails_I.Categories.find(cat => cat.Name == "Ofertas") : null;
        } catch (error) {
            console.error(".Find error:", error);
        }
        return offerCategory != null ? true : false;
    }

    getPartNumber() {
        let partNumberCf;
        try {
            partNumberCf = this.props.itemDetails.CustomFields.find(x => x.Code == process.env.CF_PART_NUMBER);
        } catch (error) {
            console.error(".Find error:", error);
        }
        let partNumber = "";

        if (partNumberCf != undefined) {
            partNumber = partNumberCf.Values[0];
        }

        return partNumber;
    }

    loadPartesRelacionadas(CFs) {
       
        let arrItems = [];
        var parte = "";
        let self = this;
        if (CFs.length) {
            CFs.map(function (cf, index) {
                if (cf.Code == process.env.CF_RELATED_PART) {
                    if (cf.Values[0].length > 0) {
                        parte = cf.Values[0];
                        arrItems = parte.split(',');
                    }
                }
            });

        }
        const searchByPartNumbers = {
            arrNumberParts: arrItems
        };
        client.CustomSearch.SearchAndFilterItemAsArcadierAPI(searchByPartNumbers).then(items => {
            self.setState({
                arrPartesRelacionadas: items.Records,
            });
        });
    }

    loadSalesUnit(CFs){
        let self = this;
        if (CFs.length) {
            CFs.map(function (cf, index) {
                if (cf.Code == process.env.CF_SALES_UNIT) {
                    if (cf.Values[0].length > 0) {
                        self.setState({
                            salesUnit: cf.Values[0] //6
                        });
                    }
                }
            });
        }

    }

    renderCarouselItemPictures() {

        const { Media } = this.props.itemDetails;
        

        if (Media) {
            var indexImgSlider = 0;
        
            var self = this;
            
            var index =0;
            return (
                <div className="myitems-carousel" style={{marginBottom:'0px'}} >
                    
                    {Media.map(function (m) {
                        
                        return (
                            <div style={{marginBottom: '50px'}}>
                                <div className="item-image" id="img-carousel">
                                    <img src={m.MediaUrl} alt="thumbnail" className="img-responsive"/>
                                </div>
                            </div>
                        );
                        index++;
                    })}
                </div>
            )
        }
    }

    render() {
        const { AverageRating } = this.props.itemDetails;
        return (
            <div>
                <div className="idcl-top preview-image full-width" id="container-product-detail">
                    <div className="images-bunch" id="container-images-detail">
                        <div id="container-info-categ-mobile">
                            <span className="item-title">{this.getPartNumber() + " " + this.props.itemDetails.BuyerDescription}</span>
                        </div>
                        {<div className="thumbnail-images" id="slick-images-item-detail">
                            <span className="top_slide text-center"><i className="fa fa-angle-up"></i></span>
                            <ul className=" slick-slider slick-vertical" />
                            <span className="bottom_slide text-center"><i className="fa fa-angle-down"></i></span>
                        </div>}

                        <div id="slick-images-item-detail-mobile">
                            {this.renderCarouselItemPictures()}
                        </div>
                        
                        <div className="idclt-img loadarea pull-left">
                            {this.renderLogoImage2()}
                        </div>
                    </div>

                    <div className="idctl-desc" id="container-description-detail">
                        {this.renderInfoItem()}

                        {this.renderPriceItem()}

                        {this.renderCFItemCore(this.props.itemDetails.CustomFields)}

                        {this.renderCorePrice()}

                        {this.renderCFUnidadVenta(this.props.itemDetails.CustomFields)}

                        <PurchaseOrderComponent
                                controlFlags={this.props.controlFlags}
                                itemDetails={this.props.itemDetails}
                                priceValues={this.props.priceValues}
                                processing={this.props.processing}
                                user={this.props.user}
                                addOrEditCart={this.props.addOrEditCart}
                                createChatChannel={this.props.createChatChannel}
                                getChatDetails={this.props.getChatDetails}
                                getUserCarts={this.props.getUserCarts}
                                getUserChannels={this.props.getUserChannels}
                                setProcessing={this.props.setProcessing}
                                updateQuantity={this.props.updateQuantity}
                                availability ={this.state.availability}
                                salesUnit = {this.state.salesUnit}/> 
                        {this.renderDimensionesMobile()}
                        {this.props.ReviewAndRating === true ? this.renderRating(AverageRating) : ''}

                    </div>
                    <AvailabiltyModalComponent user={this.props.user} partNumber={this.getPartNumber()} item_state={this.state} modalHeader={this.props.itemDetails.Name} />
                </div>
                
                <div>
                    <ItemsPartesComponent user={this.props.user} items={this.state.arrPartesRelacionadas} />
                </div>
                <div>
                    <BannersItemDetail />
                </div>
                {/*<ItemsHome user={this.props.user} />*/}
            </div>
        );
    }
}

module.exports = ItemInfoComponent;